// src/auth/adminView.js
//
// Pure, framework-free helpers for the ADMIN read-view bypass in the pack readers.
// An admin may LOAD a pack's PAID content in the reader without holding an
// entitlement -- firestore.rules already permits admin paidItems reads
// (firestore.rules:254-257: isAdmin() || isTutor() || hasActiveEntitlement); this
// lifts the STRICTER client gate (PackReaderGrouped/PackReaderSetText fetch paid
// items only when `entitled`) to match, so Felix/Danielle can review a pack's paid
// content without granting themselves an entitlement.
//
// Scope guardrails (dispatch): ADMIN ONLY -- tutors do NOT bypass (a tutor still
// needs a granted entitlement). This is a client VIEW decision, not a security
// boundary: the rules + Cloud Functions independently enforce access, and NO
// entitlement record / purchase / grant logic is touched. JSX-free so it unit-tests
// under `node --test` without importing React/firebase.

// Does this ID-token claims object grant the admin read-view? ONLY role==='admin'.
// tutor / student / content_editor / missing claims -> false (tutors must NOT
// bypass -- deliberate, per Felix).
export function roleGrantsAdminView(claims) {
    return claims?.role === 'admin';
}

// Whether the reader may load/show PAID content: a real active entitlement OR an
// admin (client bypass of the read gate the rules already allow). Never depends on
// tutor/student role.
export function readerEntitled({ realEntitlement, isAdmin }) {
    return !!realEntitlement || !!isAdmin;
}

// Whether the admin is seeing paid content ONLY because of the bypass (i.e. no real
// entitlement) -- drives the subtle "Admin view" indicator. An admin who also holds
// a real entitlement is just a normal entitled viewer (no indicator).
export function adminBypassActive({ realEntitlement, isAdmin }) {
    return !!isAdmin && !realEntitlement;
}
